import styled from 'styled-components';

export const UI_Wrapper = styled.div`
  width: 300px;
  height: 500px;
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: white;
  border-radius: 8px;
`;

export const UI_Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
`;
export const UI_HeaderLeft = styled.div`
  padding: 0px 20px;
  display: flex;
  height: 100%;
  align-items: center;
`;

export const UI_HeaderLeft_TabHeader = styled.div`
  cursor: pointer;
  color: #64748b;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0px 12px;
  font-weight: 500;
  font-size: 13px;
  user-select: none;
  transition: all 0.2s ease;

  &:hover {
    color: #1e293b;
    background-color: rgba(0, 0, 0, 0.02);
  }

  &.active {
    color: #2563eb;
    border-bottom: 2px solid #2563eb;
    font-weight: 600;
  }
`;

export const UI_HeaderRight = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0 8px;
  min-width: fit-content;
`;
export const UI_HeaderRight_item = styled.div`
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: #f0f0f0;
  }

  &.active {
    background-color: var(--color-primary);
    color: white;
  }
`;

export const UI_GroupWrapper = styled.div`
  border-bottom: 1px solid #e0e0e0;
`;

export const UI_GroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666;
  cursor: pointer;
  padding: 8px;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const UI_GroupContent = styled.div`
  padding: 8px;
`;
